import { gql } from "@stadium/services/apollo-client";

export const REMOVE_PRODUCT_FROM_DRAFT_AUTOMATED_CATALOG = gql`
  mutation RemoveProductFromDraftAutomatedCatalog(
    $input: RemoveProductFromDraftAutomatedCatalogInput!
  ) {
    removeProductFromDraftAutomatedCatalog(input: $input) {
      paginatedProducts {
        total
        countryWiseProductCount
        globalProductCount
        totalColorOptions
        totalProductsCount
        products {
          id
          name
          slug
          availableGlobally
          availableCountries {
            iso
            name
          }
          brand {
            id
            name
          }
          images
          selectedColorOptions {
            id
            name
            presentation
          }
          selectedColorsWithTemplate {
            images
            optionValue {
              id
              name
              presentation
            }
          }
        }
      }
      errors
    }
  }
`;
